"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcMeterInvoices = void 0;
const UcMeterInvoices_yaml_component_1 = __importDefault(require("./UcMeterInvoices.yaml?component"));
exports.UcMeterInvoices = UcMeterInvoices_yaml_component_1.default;
